import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import axios from '../utils/http';
import { AMap } from '../utils/amap'; // 引入加载地图的函数

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);

// 在Vue实例初始化之前异步加载地图
(async () => {
    try {
        const AMapInstance = await AMap(); // 调用AMap函数加载地图
        Vue.prototype.$AMap = AMapInstance; // 将地图实例挂载到Vue原型上
        new Vue({
            router,
            render: h => h(App),
        }).$mount('#app');
    } catch (error) {
        console.error('Error loading AMap:', error);
    }
})();
